import { requestWithToken } from '../utilities/request';
import _ from 'lodash';
const path = '/api/private/ccus/masters';

// 職種名
const jobs = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/ginou_syokusyus'),
    params: param,
  });
};

// 登録基幹技能者名称
const coreTechnicians = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/touroku_kikan_ginousyas'),
    params: param,
  });
};

// 技能士名称
const engineerLicenses = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/technician_licentiates'),
    params: param,
  });
};

// 免許資格名称
const licenses = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/qualification_license_licentiates'),
    params: param,
  });
};

/**
 * 登録基幹技能者の有効期間取得API
 * @param {Object} params
 * */
const fetchCoreTechnicianValidPeriods = params => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/core_technician_valid_periods'),
    params,
  });
};

/**
 * 保有資格の有効期間取得API
 * @param {Object} params
 * */
const fetchLicentiateValidPeriods = params => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/licentiate_valid_periods'),
    params,
  });
};

// 技能講習名称
const trainings = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/skill_course_licentiates'),
    params: param,
  });
};

// 特別教育名称
const specialTrainings = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/special_education_licentiates'),
    params: param,
  });
};

// 安全衛生講習名称
const safetyTrainings = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/other_licentiates'),
    params: param,
  });
};

// 表彰名
const commendations = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/commendations'),
    params: param,
  });
};

/**
 * 健康保険適用除外理由取得API
 * */
const healthInsuranceReasonExclusion = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/health_ins_reasons'),
    params: param,
  });
};

/**
 * 健康保険種類取得API
 * */
const healthInsuranceType = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/health_ins_types'),
    params: param,
  });
};

/**
 * 年金適用除外理由取得API
 * */
const pensionReasonExclusion = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/pension_ins_reasons'),
    params: param,
  });
};

/**
 * 年金種類名称取得API
 * */
const pensionType = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/pension_ins_types'),
    params: param,
  });
};

/**
 * 雇用保険適用除外理由取得API
 * */
const employmentInsuranceReasonExclusion = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/employment_ins_reasons'),
    params: param,
  });
};

/**
 * 被保険者種類名称取得API
 * */
const employmentInsuranceType = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('/employment_ins_types'),
    params: param,
  });
};

// 続柄
const relationship = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/family_relationships`,
    params: param,
  });
};

// 労務安全基本情報 - 在留資格
const residentStatus = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/resident_statuses`,
    params: param,
  });
};

/**
 * 年金適用除外理由を取得する
 * @param {string} code：適用除外理由コード
 * @param {object} exclusionList：適用除外理由のコードと日本語名のリスト
 * @return {?string} 適用除外理由（コードに対応する理由がない場合はnull）
 * */
const getPensionExclusionReason = (code, exclusionList) => {
  let reason = null;
  const exclusion = _.find(exclusionList, ex => {
    return ex.ccus_pension_reason_exclusion_code === code;
  });
  if (!_.isNil(exclusion)) {
    reason = exclusion.pension_reason_exclusion;
  }
  return reason;
};

/**
 * 雇用保険適用除外理由を取得する
 * @param {string} code：適用除外理由コード
 * @param {object} exclusionList：適用除外理由のコードと日本語名のリスト
 * @return {?string} 適用除外理由（コードに対応する理由がない場合はnull）
 * */
const getEmploymentInsExclusionReason = (code, exclusionList) => {
  let reason = null;
  const exclusion = _.find(exclusionList, ex => {
    return ex.ccus_employment_insurance_reason_exclusion_code === code;
  });
  if (!_.isNil(exclusion)) {
    reason = exclusion.employment_insurance_reason_exclusion;
  }
  return reason;
};

/**
 * 健康保険適用除外理由を取得する
 * @param {string} code：適用除外理由コード
 * @param {object} exclusionList：適用除外理由のコードと日本語名のリスト
 * @return {?string} 適用除外理由（コードに対応する理由がない場合はnull）
 * */
const getHealthInsExclusionReason = (code, exclusionList) => {
  let reason = null;
  const exclusion = _.find(exclusionList, ex => {
    return ex.ccus_health_insurance_reason_exclusion_code === code;
  });
  if (!_.isNil(exclusion)) {
    reason = exclusion.health_insurance_reason_exclusion;
  }
  return reason;
};

export const CcusMasterService = {
  jobs,
  coreTechnicians,
  engineerLicenses,
  licenses,
  fetchCoreTechnicianValidPeriods,
  fetchLicentiateValidPeriods,
  trainings,
  specialTrainings,
  safetyTrainings,
  commendations,
  healthInsuranceReasonExclusion,
  healthInsuranceType,
  pensionReasonExclusion,
  pensionType,
  employmentInsuranceReasonExclusion,
  employmentInsuranceType,
  relationship,
  residentStatus,
  getPensionExclusionReason,
  getEmploymentInsExclusionReason,
  getHealthInsExclusionReason,
};

export default CcusMasterService;



// WEBPACK FOOTER //
// ./src/services/CcusMasters.js